import styled from "styled-components";

import { Link } from "@olist/design-system";

export const LinkButton = styled(Link)`
  background-color: ${({ theme }) => theme.olist.color.primary.base};
  border-radius: 20px;
  color: white;
  padding: 16px;
`;
